import { render } from "./SampleAssets.vue?vue&type=template&id=31a624d6&scoped=true"
import script from "./SampleAssets.vue?vue&type=script&lang=js"
export * from "./SampleAssets.vue?vue&type=script&lang=js"

import "./SampleAssets.vue?vue&type=style&index=0&id=31a624d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a624d6"]])

export default __exports__